import "./LoadingModal.tsx";
import css from "./LoadingModal.module.scss";

interface LoadingModalProps {
  show: boolean;
  text?: string;
}

export const LoadingModal  = (e:LoadingModalProps) => {
  if (!e.show) return null;

  return (
    <div className={css.loadingOverlay}>
      <div className={css.loadingContent}>
        <div className={css.loadingSpinner}></div>
        {e.text && <p className={css.loadingText}>{e.text}</p>}
      </div>
    </div>
  );
};